/******/ (() => { // webpackBootstrap
class CartUpdateModal extends HTMLElement {
  constructor() {
    super();
    this.updateElement = this.querySelector('cart-update');
    this.input = this.querySelector('textarea');
    this.label = this.querySelector('[data-cart-update-label]');
    this.openButton = this.querySelector('[data-cart-update-open]');
    this.openButtonText = this.querySelector('[data-cart-update-open-text]');
    this.saveButton = this.querySelector('[data-cart-update-save]');
    this.cancelElements = this.querySelectorAll('[data-cart-update-cancel]');
    this.modal = this.querySelector('[data-cart-update-modal]');
    this.handleOpen = this.handleOpen.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-update-modal'});
    if (!this.input || !this.modal || !this.openButton) return;
    this.inputValue = this.input.value;
    this.openButton.addEventListener('click', this.handleOpen);
    this.saveButton?.addEventListener('click', this.handleSave);
    this.cancelElements.forEach((element) => element.addEventListener('click', this.handleCancel));
    this.addEventListener('keydown', this.handleKeydown);
    this.addEventListener('keyup', this.handleKeyup);
  }

  disconnectedCallback() {
    this.openButton?.removeEventListener('click', this.handleOpen);
    this.saveButton?.removeEventListener('click', this.handleSave);
    this.cancelElements.forEach((element) => element.removeEventListener('click', this.handleCancel));
    this.removeEventListener('keydown', this.handleKeydown);
    this.removeEventListener('keyup', this.handleKeyup);
  }

  handleOpen() {
    this.setAttribute('open', '');
    this.modal.setAttribute('aria-hidden', 'false');
    this.modal.removeAttribute('inert');
    this.openButton.setAttribute('aria-expanded', 'true');
    this.label.textContent = this.inputValue ? this.editLabelText : this.addLabelText;
    this.input.focus({preventScroll: true});
    window.setTimeout(() => {
      if (this.hasAttribute('open')) this.input.focus({preventScroll: true});
    }, 50);
  }

  async handleSave() {
    if (!this.updateElement || this.saveButton?.disabled) return;
    const saved = await this.updateElement.save();
    if (!saved) return;
    this.inputValue = this.input.value;
    this.closest('cart-drawer')?.announce(this.updateElement.dataset.successMessage || 'Cart note saved.');
    this.closeModal({ restoreInput: false });
  }

  handleCancel() {
    this.closeModal({ restoreInput: true });
  }

  closeModal({ restoreInput = false } = {}) {
    if (restoreInput) this.input.value = this.inputValue;
    this.removeAttribute('open');
    this.modal.setAttribute('aria-hidden', 'true');
    this.modal.setAttribute('inert', '');
    this.openButton.setAttribute('aria-expanded', 'false');
    this.openButtonText.textContent = this.inputValue ? this.editLabelText : this.addLabelText;
    this.openButton.focus();
  }

  handleKeydown(event) {
    if (!this.hasAttribute('open')) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      this.suppressEscapeKeyup = true;
      this.handleCancel();
      return;
    }

    if (event.key !== 'Tab') return;
    const focusableElements = this.getFocusableElements();
    if (!focusableElements.length) return;
    const first = focusableElements[0];
    const last = focusableElements[focusableElements.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  handleKeyup(event) {
    if (event.key !== 'Escape' || !this.suppressEscapeKeyup) return;
    event.preventDefault();
    event.stopPropagation();
    this.suppressEscapeKeyup = false;
  }

  getFocusableElements() {
    return [...this.modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.disabled && !element.hidden && element.getAttribute('aria-hidden') !== 'true');
  }

  setSaveBusy(isBusy) {
    if (!this.saveButton) return;
    this.saveButton.disabled = isBusy;
    this.saveButton.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  get addLabelText() {
    return this.dataset.addLabel;
  }

  get editLabelText() {
    return this.dataset.editLabel;
  }
}

customElements.define('cart-update-modal', CartUpdateModal);
/******/ })()
;
